"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CalloutAlert = function CalloutAlert(_ref) {
  var error = _ref.error;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "row column"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "callout alert small"
  }, /*#__PURE__*/_react["default"].createElement("h5", null, "Oops!"), /*#__PURE__*/_react["default"].createElement("p", null, error.description, /*#__PURE__*/_react["default"].createElement("br", null), "If the error persists, in order to help us debug the issue, please copy the URL and this message and send it to us via ", /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://www.ebi.ac.uk/support/gxasc"
  }, "the EBI Support & Feedback system"), ":"), /*#__PURE__*/_react["default"].createElement("code", null, "".concat(error.name, ": ").concat(error.message))));
};
CalloutAlert.propTypes = {
  error: _propTypes["default"].shape({
    description: _propTypes["default"].string.isRequired,
    name: _propTypes["default"].string.isRequired,
    message: _propTypes["default"].string.isRequired
  })
};
var _default = exports["default"] = CalloutAlert;